{
  "accountInformationText": "براہ کرم ذیل میں اپنی ذاتی اکاؤنٹ کی تفصیلات اپ ڈیٹ کریں۔",
  "accountSettings": "اکاؤنٹ کی ترتیبات",
  "accountStatus": "اکاؤنٹ کی حیثیت",
  "accountStatusText": "آپ کا اکاؤنٹ فی الحال اچھی حالت میں ہے۔",
  "active": "فعال",
  "administrator": "ایڈمنسٹریٹر",
  "backupCodeFailed": "بیک اپ کوڈ کی تصدیق ناکام ہو گئی۔",
  "backupCodes": "بیک اپ کوڈز",
  "backupCodesWarning": "یہ کوڈز صرف ایک مرتبہ دکھائے جائیں گے۔ انہیں محفوظ جگہ پر رکھیں۔ ہر کوڈ صرف ایک مرتبہ استعمال کیا جا سکتا ہے۔",
  "changePassword": "پاس ورڈ تبدیل کریں",
  "confirmPassword": "پاس ورڈ کی تصدیق کریں",
  "copyBackupCodes": "بیک اپ کوڈز کاپی کریں",
  "currentPassword": "موجودہ پاس ورڈ",
  "darkMode": "ڈارک موڈ",
  "depositWithdrawalAlerts": "ڈپازٹ اور وڈڈرال الرٹس",
  "disable2FA": "2FA غیر فعال کریں",
  "disable2fa": "گوگل آتھینٹیکیٹر غیر فعال کریں",
  "downloadBackupCodes": "بیک اپ کوڈز ڈاؤن لوڈ کریں",
  "emailNotifications": "ای میل اطلاعات",
  "enterAuthenticatorCode": "اپنی آتھینٹیکیٹر ایپ سے 6 ہندسوں کا کوڈ درج کریں",
  "enterAuthenticatorCodeFirst": "براہ کرم پہلے آتھینٹیکیٹر کوڈ درج کریں۔",
  "enterSixDigitCode": "6 ہندسوں کا کوڈ درج کریں",
  "goToKycVerification": "KYC تصدیق پر جائیں",
  "googleAuthenticator2fa": "گوگل آتھینٹیکیٹر (2FA)",
  "googleAuthenticator2faText": "گوگل آتھینٹیکیٹر کے ذریعے اپنے اکاؤنٹ میں سیکیورٹی کی ایک اضافی تہہ شامل کریں۔",
  "googleAuthenticatorDisabled": "گوگل آتھینٹیکیٹر غیر فعال کر دیا گیا ہے۔",
  "googleAuthenticatorEnabled": "گوگل آتھینٹیکیٹر فعال کر دیا گیا ہے۔",
  "inactive": "غیر فعال",
  "invalidCode": "کوڈ غلط ہے۔ براہ کرم دوبارہ کوشش کریں۔",
  "invalidVerificationCode": "توثیقی کوڈ غلط ہے۔",
  "kycStatusText": "مکمل اکاؤنٹ خصوصیات کھولنے کے لیے شناختی تصدیق مکمل کریں۔",
  "language": "زبان",
  "languagePreferencesText": "اپنے اکاؤنٹ میں استعمال ہونے والی زبان منتخب کریں۔",
  "languageSettings": "زبان کی ترتیبات",
  "lightMode": "لائٹ موڈ",
  "loading": "لوڈ ہو رہا ہے...",
  "loginAlerts": "لاگ ان الرٹس",
  "manualSetupKey": "دستی سیٹ اپ کلید",
  "newBackupCodesGenerated": "نئے بیک اپ کوڈز بن گئے ہیں۔ انہیں محفوظ جگہ پر رکھیں۔",
  "newPassword": "نیا پاس ورڈ",
  "notificationPreferences": "اطلاعات کی ترجیحات",
  "notificationPreferencesText": "منتخب کریں کہ آپ کون سی الرٹس موصول کرنا چاہتے ہیں۔",
  "notificationSettings": "اطلاعات کی ترتیبات",
  "owner": "مالک",
  "ownerControlCenter": "مالک کنٹرول سینٹر",
  "ownerDisableBlocked": "مالک اکاؤنٹ گوگل آتھینٹیکیٹر کو غیر فعال نہیں کر سکتا۔",
  "p2pAlerts": "P2P الرٹس",
  "p2pOrderAlerts": "P2P آرڈر الرٹس",
  "pushNotifications": "پش اطلاعات",
  "regenerateBackupCodes": "نئے بیک اپ کوڈز بنائیں",
  "require2FASetup": "جاری رکھنے سے پہلے گوگل آتھینٹیکیٹر سیٹ اپ ضروری ہے۔",
  "role": "رول",
  "saveBackupCodes": "بیک اپ کوڈز محفوظ کریں",
  "saveChanges": "تبدیلیاں محفوظ کریں",
  "saving": "محفوظ ہو رہا ہے...",
  "scanQrCode": "یہ QR کوڈ اسکین کریں",
  "scanQrCodeAuthenticator": "اپنی آتھینٹیکیٹر ایپ سے یہ QR کوڈ اسکین کریں",
  "securityAlerts": "سیکیورٹی الرٹس",
  "securityRules": "سیکیورٹی قواعد",
  "securitySettings": "سیکیورٹی کی ترتیبات",
  "selectLanguage": "زبان منتخب کریں",
  "serverError": "سرور میں خرابی۔",
  "sessionExpired": "سیشن ختم ہو گیا ہے۔ براہ کرم دوبارہ لاگ ان کریں۔",
  "settingRuleBotProtection": "اس اکاؤنٹ پر خودکار بوٹ سرگرمی سے تحفظ فعال ہے۔",
  "settingRuleDepositReview": "آپ کے بیلنس میں شامل کرنے سے پہلے بڑی رقوم کی جانچ کی جاتی ہے۔",
  "settingRuleKyc": "نکاسی کی منظوری سے پہلے شناختی تصدیق لازمی ہے۔",
  "settingRuleManualReview": "مشکوک سرگرمی دستی سیکیورٹی جانچ کا سبب بن سکتی ہے۔",
  "settingRuleWalletMatch": "نکاسی کے لیے تصدیق شدہ والیٹ ایڈریس سے مطابقت ضروری ہے۔",
  "settingsSubtitle": "اپنا اکاؤنٹ، زبان، توثیق اور سیکیورٹی کا نظم کریں۔",
  "settingsTitle": "ترتیبات اور سیکیورٹی",
  "settingsUpdateFailed": "ترتیبات اپ ڈیٹ کرنے میں ناکامی۔",
  "settingsUpdated": "ترتیبات کامیابی سے اپ ڈیٹ ہو گئیں۔",
  "setup2FA": "گوگل آتھینٹیکیٹر سیٹ اپ کریں",
  "setupGoogleAuthenticator": "گوگل آتھینٹیکیٹر سیٹ اپ کریں",
  "systemDefault": "سسٹم ڈیفالٹ",
  "theme": "تھیم",
  "twoFaSetupFailed": "دو مرحلہ توثیق کا سیٹ اپ ناکام ہو گیا۔",
  "twoFactorAuthentication": "گوگل آتھینٹیکیٹر (2FA)",
  "twoFactorDescription": "اپنے اکاؤنٹ کو گوگل آتھینٹیکیٹر سے محفوظ بنائیں۔",
  "twoFactorDisabled": "دو مرحلہ توثیق غیر فعال ہو گئی",
  "twoFactorDisabledSuccess": "گوگل آتھینٹیکیٹر کامیابی سے غیر فعال ہو گیا۔",
  "twoFactorEnabled": "دو مرحلہ توثیق فعال ہو گئی",
  "twoFactorSecurity": "دو مرحلہ سیکیورٹی",
  "twoFactorSecurityText": "مضبوط اکاؤنٹ تحفظ کے لیے دو مرحلہ توثیق فعال کریں۔",
  "twoFactorSetupFailed": "2FA سیٹ اپ ناکام ہو گیا۔",
  "twoFactorVerified": "گوگل آتھینٹیکیٹر کامیابی سے فعال ہو گیا۔",
  "user": "یوزر",
  "verificationCode": "توثیقی کوڈ",
  "verify2FA": "تصدیق کریں اور فعال کریں",
  "verifyAndEnable": "تصدیق کریں اور فعال کریں"
}